/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_ACCOUNT_DETAIL,
  GET_ACCOUNT_DETAIL_SUCCESS,
  GET_ACCOUNT_DETAIL_FAILURE,
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse,
} from "./reducerUtils";

const initialState = {
  data: null,
  state: "INIT",
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ACCOUNT_DETAIL:
      return setLoadingState(state);

    case GET_ACCOUNT_DETAIL_SUCCESS:
      return setSuccessResponse(state, action);

    case GET_ACCOUNT_DETAIL_FAILURE:
      return setErrorResponse(state, action);
    default:
      return state;
  }
}
